const FreelancerPaymentExportStatusEnum=
{
    Created:'Created',
    Exported:'Exported',
};

export default FreelancerPaymentExportStatusEnum;